<template>

  <b-modal :id="'modal-add-child'+item.id" :ref="'modal-add-child'" centered scrollable hide-header-close
           title="اضافه کردن آیتم به زیرمجموعه" header-bg-variant="dark"
           header-text-variant="light" @ok="onSubmit" @cancel="resetChild">

    <form @submit.stop.prevent="onSubmit">

      <form-group :validations="$v.childItem.name">
        <div slot-scope="{ errors, invalid }">
          <b-form-input type="text" class="m-1" v-model="childItem.name" placeholder="عنوان آیتم"/>
          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>

      <form-group :validations="$v.childItem.url">
        <div slot-scope="{ errors, invalid }">
          <b-form-input type="url" class="m-1" v-model="childItem.url" placeholder="آدرس اینترنتی"/>
          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>



      <form-group :validations="$v.childItem.color">
        <div slot-scope="{ errors, invalid }">
          <b-form-input type="color" class="m-1" v-model="childItem.color"/>
          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>

    </form>

    <template #modal-footer="{ ok, cancel}">
      <b-row class="d-flex flex-row justify-content-around w-100">
        <b-button size="md" variant="success" @click="ok()">
          ثبت آیتم
        </b-button>
        <b-button size="md" variant="danger" @click="cancel()">
          انصراف
        </b-button>
      </b-row>
    </template>
  </b-modal>

</template>

<script>
import FormGroup from "../../validator/FormGroup";
import {required,url} from "vuelidate/lib/validators";
import FormErrorsManager from '../../validator/FormErrorsManager.vue'


export default {
  name: "CreateItemChildModalForm",
  props: ['item'],
  components:{ FormGroup, FormErrorsManager},
  data() {
    return {
      childItem: {
        menu_id: parseInt(this.$route.params.id),
        target: this.item.target,
        order: this.item.order,
        parent_id: parseInt(this.item.id),
        name: '',
        url: '',
        icon_class: '',
        color: '#FFFFFF',
        status: 0,
      },
    }
  },
  validations: {
    childItem: {
      name: {required},
      url: {required,url},
      color: {required},
    },
  },
  methods: {
    checkIcon(){
      if(this.childItem.icon_class === ''){
        this.childItem.icon_class = 'ban'
      }else{
        this.childItem.icon_class = this.childItem.icon_class.name
      }
    },
    addChild() {
      this.checkIcon()
      this.$store.dispatch("Menu/createItem", this.childItem)
    },
    resetChild(){
      this.childItem = {
        menu_id: parseInt(this.$route.params.id),
        target: this.item.target,
        order: this.item.order,
        parent_id: parseInt(this.item.id),
        name: '',
        url: '',
        icon_class: '',
        color: '#FFFFFF',
      }
    },
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit(bvModalEvent){
      bvModalEvent.preventDefault()
      if (this.invalid()) {
        this.addChild()
        this.$nextTick(() => {
          this.$bvModal.hide('modal-add-child'+this.item.id)
          this.resetChild()
        })
      }
    }
  }
}
</script>

<style scoped>
.set-font {
  font-size: 12px;
}

.item-row {
  padding: 2px;
  border-radius: 4px;
  border: 1px solid grey;
  margin: 4px 0 4px;
  width: 100%;
  background-color: transparent;
}

.cls-btn {
  padding: 0;
  margin: 0;
  color: black;
  background-color: transparent;
  border: none;
  width: 100%;
}

.cls-btn:hover {
  color: black;
  background-color: transparent;
  border: none;
}

.cls-btn:focus {
  color: black;
  border: 2px solid grey;
}
</style>